/**
 * Find an @mention trigger in the current textblock before the cursor.
 * Returns ProseMirror positions { query, from, to } or null.
 */
export function findMentionTrigger(editor) {
  if (!editor) return null;

  const { $from } = editor.state.selection;
  if (!$from.parent.isTextblock) return null;

  const parentStart = $from.start();
  const cursorOffset = $from.parentOffset;
  let text = '';
  const stringIndexToParentOffset = [];

  $from.parent.forEach((child, offset) => {
    if (offset >= cursorOffset) return false;
    if (!child.isText || !child.text) return undefined;

    const end = Math.min(offset + child.text.length, cursorOffset);
    const slice = child.text.slice(0, end - offset);
    for (let i = 0; i < slice.length; i += 1) {
      stringIndexToParentOffset[text.length] = offset + i;
      text += slice[i];
    }
    return undefined;
  });

  const match = text.match(/(?:^|[\s\n])@([^\n@]*)$/);
  if (!match) return null;

  const atIndex = text.lastIndexOf('@');
  if (atIndex < 0 || stringIndexToParentOffset[atIndex] == null) return null;

  return {
    query: match[1],
    from: parentStart + stringIndexToParentOffset[atIndex],
    to: $from.pos,
  };
}

export function collectMentionItems(editor) {
  if (!editor) return [];

  const items = [];
  const seen = new Set();

  editor.state.doc.descendants(node => {
    if (node.type.name !== 'copilotMention') return true;

    const item = {
      type: node.attrs.type,
      id: node.attrs.id,
      name: node.attrs.name,
      subtitle: node.attrs.subtitle || undefined,
      portalSlug: node.attrs.portalSlug || undefined,
    };
    const key = `${item.type}:${item.id}`;
    if (!seen.has(key)) {
      seen.add(key);
      items.push(item);
    }
    return true;
  });

  return items;
}
